import trackOrder from 'sales-flow-ui/domains/track-order/store';
import orderSummary from 'sales-flow-ui/domains/order-summary/store';
import contact from 'sales-flow-ui/domains/contact/store';
import sales from 'sales-flow-ui/domains/sales/store';
import checkout from 'sales-flow-ui/domains/checkout/store';
import thankYou from 'sales-flow-ui/domains/thank-you/store';
import cart from 'sales-flow-ui/domains/cart/store';
import collection from 'sales-flow-ui/domains/collection/store';
import dataCollection from 'sales-flow-ui/domains/data-collection/store';
import Vue from 'vue';
import Vuex from 'vuex';

import baseIndex from 'viralstyle-ui/src/baseIndex';
import base from 'domains/base/store';
import home from 'domains/home/store';

Vue.use(Vuex);

baseIndex.actions = { ...baseIndex.actions, ...base.actions };
baseIndex.getters = base.getters;
baseIndex.state = { ...baseIndex.state, ...base.state };
baseIndex.mutations = { ...baseIndex.mutations, ...base.mutations };

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  ...baseIndex,
  modules: {
    sales,
    checkout,
    thankYou,
    cart,
    trackOrder,
    orderSummary,
    home,
    contact,
    collection,
    dataCollection,
  },
});

if (module.hot) {
  module.hot.accept([
    'viralstyle-ui/src/baseIndex',
    'domains/base/store',
    'sales-flow-ui/domains/sales/store',
    'sales-flow-ui/domains/checkout/store',
    'sales-flow-ui/domains/thank-you/store',
    'sales-flow-ui/domains/cart/store',
    'sales-flow-ui/domains/track-order/store',
    'sales-flow-ui/domains/order-summary/store',
    'domains/home/store',
    'sales-flow-ui/domains/contact/store',
    'sales-flow-ui/domains/collection/store',
    'sales-flow-ui/domains/data-collection/store',
  ], () => {
    let baseIndexHot = require('viralstyle-ui/src/baseIndex').default,
      baseHot = require('domains/base/store').default;

    baseIndexHot.actions = { ...baseIndexHot.actions, ...baseHot.actions };
    baseIndex.getters = base.getters;
    baseIndexHot.state = { ...baseIndexHot.state, ...baseHot.state };
    baseIndexHot.mutations = { ...baseIndexHot.mutations, ...baseHot.mutations };

    store.hotUpdate({
      actions: baseIndexHot.actions,
      state: baseIndexHot.state,
      mutations: baseIndexHot.mutations,
      modules: {
        sales: require('sales-flow-ui/domains/sales/store').default,
        checkout: require('sales-flow-ui/domains/checkout/store').default,
        thankYou: require('sales-flow-ui/domains/thank-you/store').default,
        cart: require('sales-flow-ui/domains/cart/store').default,
        trackOrder: require('sales-flow-ui/domains/track-order/store').default,
        orderSummary: require('sales-flow-ui/domains/order-summary/store').default,
        home: require('domains/home/store').default,
        contact: require('sales-flow-ui/domains/contact/store').default,
        collection: require('sales-flow-ui/domains/collection/store').default,
        dataCollection: require('sales-flow-ui/domains/data-collection/store').default,
      },
    });
  });
}

export default store;